import { mapState } from 'vuex'
import log from '@/logger'
import { ls } from '@/services/storage'
import brandsList from '@/components/brands-list/brands-list.vue'
import connectionLostModal from '@/components/connection-lost-modal/connection-lost-modal.vue'
import globalLogin from '@/components/global-login/global-login.vue'
import pageFooter from '@/components/page-footer/page-footer.vue'
import pageHeader from '@/components/page-header/page-header.vue'

export default {
  components: {
    brandsList,
    connectionLostModal,
    globalLogin,
    pageFooter,
    pageHeader
  },
  metaInfo () {
    const brandName = this.BRAND?.name || '+'
    return {
      titleTemplate: title => {
        return title ? `${title} | ${brandName} Win+` : `${brandName} Win+`
      }
    }
  },
  computed: {
    ...mapState('errors', ['connectionError']),
    brandColorsStyles () {
      if (this.BRAND) {
        return {
          '--color-primary': this.BRAND.colorPrimary,
          '--color-primary-hover': this.BRAND.colorPrimaryHover,
          '--color-white-hover': this.BRAND.colorWhiteHover
        }
      }
    }
  },
  async created () {
    try {
      this.loadingStart()
      await this.$store.dispatch('app/loadInit')

      ls.watch('auth-v2', newVal => {
        if (newVal) {
          this.$store.commit('auth/setAuth', newVal)
        } else {
          this.$store.dispatch('auth/logout')
        }
      })
      ls.watchExpire('auth-v2')

      ls.watch('player-v2', newVal => {
        if (newVal) {
          this.$store.commit('players/updatePlayer', newVal)
        } else {
          this.$store.commit('players/deletePlayer')
        }
      })
    } catch (error) {
      log.error('app.create', error)
    } finally {
      this.loadingEnd()
    }
  }
}
